import React from "react";
import { Route } from "react-router-dom";
import { menuConfig } from "../configs/MenuConfig";
import * as AdminPages from "../pages/admin";
import AdminPanel from "../pages/admin/AdminPanel";
import AdminProfileEdit from "../pages/admin/AdminProfileEdit";
import PanelLayout from"../layouts/PanelLayout";
import UserRegister from "../pages/admin/UserRegister";
import ProtectedRoute from "../components/ProtectedRoute";
import CustomerProfileAdmin from "../pages/admin/UserProfile/CustomerProfileAdmin";
import CustomerProfileAdminEdit from "../pages/admin/UserProfile/CustomerProfileAdminEdit";
import EmployeeProfileAdmin from "../pages/admin/UserProfile/EmployeeProfileAdmin";
import EmployeeProfileAdminEdit from "../pages/admin/UserProfile/EmployeeProfileAdminEdit";
import SupplierProfileAdmin from "../pages/admin/UserProfile/SupplierProfileAdmin";
import SupplierProfileAdminEdit from "../pages/admin/UserProfile/SupplierProfileAdminEdit";
import CarrierProfileAdmin from "../pages/admin/UserProfile/CarrierProfileAdmin";
import CarrierProfileAdminEdit from "../pages/admin/UserProfile/CarrierProfileAdminEdit";
import DriverProfileAdmin from "../pages/admin/UserProfile/DriverProfileAdmin";
import DriverProfileAdminEdit from "../pages/admin/UserProfile/DriverProfileAdminEdit";
import ProductIncpection from "../pages/admin/ProductIncpection"
import AdminPDP from "../pages/admin/product/AdminPDP";
import CampaignFormPage from "../pages/campaign/CampaignFormPage";



function renderRoutes(items = []) {
  return items.map(({ link, component, submenu }) => {
    if (link === '/password-setting/') {
      return null;
    }
    const Page = component ? AdminPages[component] : undefined;

    return (
      <Route key={link} path={link} element={Page ? <Page /> : undefined}>
        {submenu && renderRoutes(submenu)}
      </Route>
    );
  });
}

export default function AdminRoutes() {
  const routes = menuConfig.admin.items;

  return (

   <Route path="/admin-panel" element={<ProtectedRoute allowedRoles={["admin"]}><PanelLayout user ='admin'/></ProtectedRoute>}>
     <Route index element={<AdminPanel />} />
       <Route path="user-register" element={<UserRegister />} />
       <Route path="customer-user-management/:id/view/" element={<CustomerProfileAdmin />} />
       <Route path="customer-user-management/:id/edit/" element={<CustomerProfileAdminEdit />} />
       <Route path="employee-user-management/:id/view/" element={<EmployeeProfileAdmin />} />
       <Route path="employee-user-management/:id/edit/" element={<EmployeeProfileAdminEdit />} />
       <Route path="supplier-user-management/:id/view/" element={<SupplierProfileAdmin />} />
       <Route path="supplier-user-management/:id/edit/" element={<SupplierProfileAdminEdit />} />
       <Route path="carrier-user-management/:id/view/" element={<CarrierProfileAdmin />} />
       <Route path="carrier-user-management/:id/edit/" element={<CarrierProfileAdminEdit />} />
       <Route path="driver-user-management/:id/view/" element={<DriverProfileAdmin />} />
       <Route path="driver-user-management/:id/edit/" element={<DriverProfileAdminEdit />} />

       <Route path="admin-product/:id" element={<AdminPDP />} />

       <Route path="product-incpection/:id/" element={<ProductIncpection />} />

       <Route path="admin-profile-edit" element={<AdminProfileEdit />} />

        <Route path="campaigns/new" element={<CampaignFormPage />} />
        <Route path="campaigns/:slug/edit" element={<CampaignFormPage />} />

        {renderRoutes(routes)}
   </Route>
);
}
